import { Component, EventEmitter, Input, Output } from '@angular/core';

import type { OfferFull } from '@recruitee/offers-types';
import { OffersPageGroupHeadingComponent } from '@recruitee/offers-ui';
import { LayoutListHeaderComponent } from '@recruitee/views-util';

@Component({
  selector: 'rt-offer-card-heading',
  imports: [OffersPageGroupHeadingComponent],
  template: `<rt-offers-page-group-heading
    [state]="isCollapsed ? 'collapsed' : 'normal'"
    [name]="recordData.group!.label"
    [counter]="(recordData.data?.meta)!.totalCount ?? 0"
    (click)="click.emit(recordData)"
  />`,
})
export class OfferListHeadingComponent implements LayoutListHeaderComponent<OfferFull> {
  @Input() public recordData: LayoutListHeaderComponent<OfferFull>['recordData'];
  @Input() public isCollapsed: boolean = false;

  @Output() public click = new EventEmitter<this['recordData']>();
}
